package com.essntl.features.tag.ui

import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.*
import androidx.compose.material.ripple.rememberRipple
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.input.key.*
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.text.SpanStyle
import androidx.compose.ui.text.buildAnnotatedString
import androidx.compose.ui.text.withStyle
import androidx.compose.ui.unit.DpOffset
import androidx.compose.ui.unit.dp
import com.essntl.features.tag.domain.model.TagModel
import com.essntl.uikit.components.dropdown.EsDropDownMenu
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.icons.EsLargeIcon
import com.essntl.uikit.components.input.EsInput
import com.essntl.uikit.components.spinner.EsSpinner
import com.essntl.uikit.components.spinner.EsSpinnerSize
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun TagDropDownMenu(
    expanded: Boolean,
    onDismissRequest: () -> Unit,
    tagList: List<TagModel>,
    selectedTagIds: Set<String>,
    onAddTag: (String) -> Unit,
    onTagToggle: (TagModel) -> Unit,
    addTag: Boolean = true,
    loading: Boolean = false,
    modifier: Modifier = Modifier,
) {
    var searchText by remember {
        mutableStateOf("")
    }
    val filteredTagList = remember(tagList, searchText) {
        tagList.filter {
            it.name.contains(searchText, ignoreCase = true)
        }
    }

    EsDropDownMenu(
        expanded = expanded,
        onDismissRequest = onDismissRequest,
        modifier = modifier,
        paddingValues = PaddingValues(
            vertical = 1.5f.spacing,
        ),
        offset = DpOffset(
            x = 0.dp,
            y = 4.dp,
        ),
    ) {
        EsInput(
            value = searchText,
            onValueChange = {
                searchText = it
            },
            placeholder = "Search",
            prefix = {
                EsLargeIcon(res = EsIcons.Search)
            },
            modifier = Modifier
                .padding(
                    horizontal = 1.5f.spacing,
                )
                .fillMaxWidth()
                .then(
                    if (addTag)
                        Modifier
                            .onPreviewKeyEvent { event ->
                                if (
                                    event.key == Key.Enter &&
                                    event.type == KeyEventType.KeyUp &&
                                    searchText.isNotEmpty()
                                ) {
                                    val tag = tagList.find { it.name.equals(searchText, true) }

                                    if (tag == null)
                                        onAddTag(searchText)
                                    else
                                        onTagToggle(tag)

                                    searchText = ""
                                    true
                                } else {
                                    false
                                }
                            }
                    else
                        Modifier,
                ),
        )

        if (loading) {
            EsSpinner(
                color = MaterialTheme.esColorScheme.iconPrimary,
                size = EsSpinnerSize.Large,
                modifier = Modifier
                    .align(Alignment.CenterHorizontally)
                    .padding(all = 1.5f.spacing),
            )
        } else if (filteredTagList.isEmpty()) {
            Text(
                text = "Nothing was found",
                color = MaterialTheme.esColorScheme.textTertiary,
                style = MaterialTheme.esTypography.p1Regular16,
                modifier = Modifier
                    .align(Alignment.Start)
                    .padding(all = 1.5f.spacing),
            )
        }

        val searchTag = remember(tagList, searchText) {
            tagList.find { it.name.equals(searchText, true) }
        }

        if (searchTag == null && searchText.isNotEmpty() && addTag) {
            Text(
                text = buildAnnotatedString {
                    append("Add ")
                    withStyle(
                        SpanStyle(
                            color = MaterialTheme.esColorScheme.textAccent,
                            fontWeight = MaterialTheme.esTypography.p1Medium16.fontWeight,
                        ),
                    ) {
                        append(searchText)
                    }
                    append(" as a new tag")
                },
                color = MaterialTheme.esColorScheme.textPrimary,
                style = MaterialTheme.esTypography.p1Regular16,
                modifier = Modifier
                    .padding(all = 1.5f.spacing)
                    .pointerHoverIcon(PointerIcon.Hand)
                    .clickable(
                        interactionSource = remember { MutableInteractionSource() },
                        indication = null,
                    ) {
                        onAddTag(searchText)
                        searchText = ""
                    },
            )
        } else {
            Spacer(modifier = Modifier.height(1f.spacing))
        }

        filteredTagList.forEach { tag ->
            val isSelected = remember(tag, selectedTagIds) {
                selectedTagIds.contains(tag.id)
            }

            key(tag.id) {
                TagDropDownItem(
                    onClick = {
                        onTagToggle(tag)
                    },
                    tag = tag,
                    selected = isSelected,
                    modifier = Modifier
                        .padding(
                            vertical = .5f.spacing,
                            horizontal = 1.5f.spacing,
                        ),
                )
            }
        }
    }
}